import gql from "graphql-tag";
import LocalBookFragments from "@/graphql/LocalBookFragments";

export default {
  getFeaturedBooks: gql`
    query getFeaturedBooks(
      $region: String,
      $order: [FeaturedBookFilter_order]
    ) {
      featuredBooks(
        region: $region,
        order: $order
      ) {
        id
        _id
        position
        region
        book {
          ...LocalBookCore
        }
      }
    }
    ${LocalBookFragments.localBookCoreFragment}
  `,
};
